;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { XMarkIcon } from '@heroicons/react/20/solid'
import { cva, VariantProps } from 'class-variance-authority'
import { ComponentProps } from 'react'

import { cn } from '../../utils/cn'
import { Badge, type BadgeEmphasis, labeledBadgeVariants } from './badge'
import { BaseButton } from './base-button'

const removableBadgeVariants = cva('inline-flex gap-1', {
  variants: {
    variant: {
      default: '',
      info: '',
      outlined: 'border-gray-300 bg-transparent',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

const removableBadgeIconVariants = cva('ml-1 h-3 w-3 self-center', {
  variants: {
    variant: {
      default: 'text-gray-700',
      info: 'text-info-700',
      outlined: 'text-gray-300',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

type BadgeProps = ComponentProps<typeof Badge>
type RemovableBadgeProps = VariantProps<typeof removableBadgeVariants> & {
  emphasis: BadgeEmphasis
  onRemove: () => void
  children: React.ReactNode
  className?: string
  size?: BadgeProps['size']
  shape?: BadgeProps['shape']
  help?: never
}
export function RemovableBadge({
  emphasis,
  onRemove,
  children,
  className,
  size,
  variant,
  shape,
}: RemovableBadgeProps) {
  return (
    <BaseButton
      className={cn(
        labeledBadgeVariants({ size, variant, shape, emphasis }),
        removableBadgeVariants({ variant }),
        className,
      )}
      onClick={onRemove}
      aria-label={`remove ${children}`}
    >
      {children}
      <XMarkIcon className={removableBadgeIconVariants({ variant })} />
    </BaseButton>
  )
}
